import { useTranslation } from "react-i18next";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";

export const ProductionAndSalesDetailAdditional = () => {
    const { t } = useTranslation();

    return (
        <>
            <NFormTable fieldArray={"additionalProducts"}>
                <NFLookupUnit title={t("Unit")} fieldName="unitId" />
                <NFIntInput title={t("Quantity")} fieldName="quantity" />
                <NFIntInput title={t("Price")} fieldName="price" />
                <NFIntInput title={t("Amount")} fieldName="amount" />
                <NFLookupAccount title={t("Account")} fieldName="accountId" />
                <NFLookupProduct title={t("Product")} fieldName="productId" />
            </NFormTable>
        </>
    );
};
